// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__tuciq","notes":"Notes_notes__3gmIS","note":"Notes_note__A9dUk","markdown":"Notes_markdown__3OUGw"};